import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import { ORDER_URL } from '../../../../../components/OrderCommon/constant';
import { RequestErrorData } from '../interface';

interface Options {
  showIndicator?: boolean;
}

export async function orderStatusRequest(url: string, data = {}, options: Options = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const params = {
    url,
    method: 'POST',
    data: {
      ...data,
      bundleVersion: Mach.env.bundleVersion ?? '',
      bundleName: Mach.env.bundleName ?? ''
    },
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  const { showIndicator = true } = options;
  if (showIndicator) {
    indicatorModule.showLoading();
  }
  let methodName = 'request';
  if (ORDER_URL.CANCEL === url && !!networkModule.requestWx) {
    methodName = 'requestWx';
  }

  return new Promise<any>((resolve, reject) => {
    networkModule?.[methodName](params, (result: any) => {
      if (showIndicator) {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        if ((typeof result.error) == 'string') {
          const errorData: RequestErrorData = {
            message: result.error
          };
          reject(errorData);
        } else {
          const errorData: RequestErrorData = {
            message: (result.error.msg || result.error.message || '[api] error')
          };
          reject(errorData);
        }
      } else {
        if (result.data && result.data.code == 0 && result.data.data) {
          resolve(result.data.data);
        } else {
          if (Mach.env.isDebug) {
            console.log('request api error: ', JSON.stringify(result));
          }

          let errorData: RequestErrorData = result.data;
          if ((typeof result.data) === 'string') {
            errorData = {
              message: result.data
            };
          } else if (!errorData) {
            errorData = {
              message: 'api [error]'
            };
          } else if (!(errorData.message || errorData.msg)) {
            errorData.message = 'API error';
          }
          reject(errorData);
        }
      }
    });
  });
}

export async function newOrderStatusRequest(url: string, data = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const params = {
    url,
    dataType: 'json',
    method: 'POST',
    data: {
      ...data,
      bundleVersion: Mach.env.bundleVersion ?? '',
      bundleName: Mach.env.bundleName ?? ''
    },
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  let methodName = 'request';
  if ((ORDER_URL.CANCEL === url || ORDER_URL.STATUTS === url) && !!networkModule.requestWx) {
    methodName = 'requestWx';
  }

  return new Promise<any>((resolve, reject) => {
    networkModule?.[methodName](params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.error) {
        if ((typeof result.error) == 'string') {
          const errorData: RequestErrorData = {
            message: result.error
          };
          reject(errorData);
        } else {
          const errorData: RequestErrorData = {
            message: (result.error.msg || result.error.message || '[api] error')
          };
          reject(errorData);
        }
      } else {
        if (result.data && result.data.code == 0 && result.data.data) {
          resolve(result.data.data);
        } else {
          if (Mach.env.isDebug) {
            console.log('request api error: ', JSON.stringify(result));
          }

          let errorData: RequestErrorData = result.data;
          if ((typeof result.data) === 'string') {
            errorData = {
              message: result.data
            };
          } else if (!errorData) {
            errorData = {
              message: 'api [error]'
            };
          } else if (!(errorData.message || errorData.msg)) {
            errorData.message = 'API error';
          }
          reject(errorData);
        }
      }
    });
  });
}

export async function storeReviewRequest(url: string, data = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const params = {
    url,
    method: 'POST',
    data: {
      ...data
    },
  };

  return new Promise<any>((resolve, reject) => {
    networkModule?.request(params, (result: any) => {
      if (result.error) {
        if ((typeof result.error) == 'string') {
          const errorData: RequestErrorData = {
            message: result.error
          };
          reject(errorData);
        } else {
          const errorData: RequestErrorData = {
            message: (result.error.msg || result.error.message || '[api] error')
          };
          reject(errorData);
        }
      } else {
        if (result.data && result.data.code == 0 && result.data.data) {
          resolve(result.data.data);
        } else {
          if (Mach.env.isDebug) {
            console.log('request api error: ', JSON.stringify(result));
          }

          let errorData: RequestErrorData = result.data;
          if ((typeof result.data) === 'string') {
            errorData = {
              message: result.data
            };
          } else if (!errorData) {
            errorData = {
              message: 'api [error]'
            };
          } else if (!(errorData.message || errorData.msg)) {
            errorData.message = 'API error';
          }
          reject(errorData);
        }
      }
    });
  });
}

const kOrderStatusPushKey = 'kOrderStatusPushKey_zhegekeyzhishibuhuichongfude';
export function checkPush() {
  const SLCommon = Mach.requireModule('SLCommon');
  if (SLCommon?.isOpenPush()) {
    // 只要是开启了,就没有必要往下判断了.直接返回 true
    return true;
  }
  if (SLCommon?.getStorage) {
    const value = SLCommon?.getStorage({
      key: kOrderStatusPushKey
    });
    if (value) {
      const timestamp = Mach.env.networkTimestamp();
      if (timestamp - parseFloat(value) < 24 * 60 * 60 * 7) {
        return true;
      }
    }
  }
  return false;
}

export function closePush() {
  const SLCommon = Mach.requireModule('SLCommon');

  let timestamp: any = Mach.env.networkTimestamp();

  // 安卓需要转成 string 才能 存储,  在 读取的时候做了 parseFloat, 所以没有问题.
  if (Mach.env.isAndroid) {
    timestamp = timestamp.toString();
  }
  console.log('timestamp = ', timestamp);
  if (SLCommon) {
    if (SLCommon?.getStorage) {
      SLCommon?.setStorage({
        key: kOrderStatusPushKey,
        value: timestamp
      });
    }
  }
}

/**
 * 多单任务弹窗接口请求
 * @param orderRequest
 */
export async function multiOrderDialogRequest(data = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'dsp/order/detail/task/pop';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    data: {
      ...data
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        if (result.data?.code === 0 && result.data.data) {
          console.log('multiOrderDialogRequest request api success!');
          resolve(result.data.data);
        } else if (result.data?.code === 1000) {
          // 1000 标识参与任务成功且无预达标提醒弹窗
          const error = i18nClient.getText('mission_after_pay_start_popup_toast');
          reject(error);
        } else {
          console.log(`multiOrderDialogRequest request api error: ${result.data.message}`);
          reject(result.data.message);
        }
      } else {
        reject('error');
      }
    });
  });
}

/**
 * 多单任务弹窗接口请求
 * @param orderRequest
 */
export async function requestMultiOrderData(data = {}): Promise<any> {
  // 判断一下是否登录
  const Login = Mach.requireModule('Login');
  const isLogin = Login?.isLogin?.();
  if (!isLogin) {
    return new Promise<any>((resolve, reject) => {
      reject({ code: 1 });
    });
  }

  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'dsp/order/detail/task/pop';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    data: {
      ...data
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      const code = result?.data?.code ?? 1;
      if (code === 0) {
        resolve(result.data);
      } else {
        reject(result.data);
      }
    });
  });
}

/**
 * 领取任务接口请求
 * @param requestParams
 */
export async function startTaskRequest(requestParams): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'v1/start/task';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...requestParams
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        if (result.data.code === 0) {
          // 接口请求成功
          console.log('start task request api success!');
          resolve(result.data.data);
        } else {
          // 接口请求失败
          console.log(`start task request api fail: ${result.data.msg}`);
          reject(result.data.msg);
        }
      } else {
        // 其他异常
        console.log('start task request api error!');
        reject('error');
      }
    });
  });
}

/**
 * 获取评价弹窗数据
 * @param requestParams EVALUATE
 */
export async function requestEvaluateData(requestParams = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'v1/order/detail/popups';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...requestParams
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      // 接口请求成功
      if (result.data?.code === 0) {
        resolve(result.data);
      } else {
        // 其他异常
        reject(result.data);
      }
    });
  });
}

// 记录订单详情页弹窗显示接口
export async function requestEvaluateShown(requestParams = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'v1/order/detail/popups/shown';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...requestParams
    }
  };
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      // 接口请求成功
      if (result.data?.code === 0) {
        resolve(result.data);
      } else {
        // 其他异常
        reject(result.data);
      }
    });
  });
}
